import { sortArray } from "./sorter"

export const userEntered = (arr: any, user: any) => {
  const newUser = {
    id: user.id,
    name: user.name,
    bet: null,
    cashout: user.cashout,
  }

  let isThereAlready = arr.some((u: any) => u.id === user.id)
  if (!isThereAlready) {
    arr.push(newUser)
  }
  return arr
}

export const userPlacedBet = (arr: any, user: any) => {
  let mapped = arr.map((u: any) =>
    u.id !== user.id
      ? u
      : {
          ...u,
          bet: user.bet,
          currency: user.currency,
        },
  )
  return sortArray(mapped)
}

export const userCanceledBet = (arr: any, user: any) => {
  return arr.map((u: any) => (u.id !== user.id ? u : { ...u, bet: null }))
}

export const userExited = (arr: any, user: any) =>
  arr.filter((u: any) => u.id !== user.id)

export const userCashouted = (arr: any, user: any) => {
  return arr.map((u: any) =>
    u.id === user.id
      ? {
          ...u,
          bet: user.bet,
          cashout: user.cashout,
          currency: user.currency,
        }
      : u,
  )
}

export const roundReset = (users: any) =>
  users.map((u: any) => {
    return { ...u, bet: null, currency: null, cashout: null }
  })

export const firstUserPush = (
  id: string,
  name: string,
  setusers: (a: any) => void,
) => {
  setusers([
    {
      id,
      name,
      bet: null,
      cashout: null,
    },
  ])
}
